// import { useIsFeatureFlagEnabled } from '@msrceng/component';
// import { FEATURE_FLAG_ADVISORY } from './constants';

// Hard coded to true. We don't have a reliable API for features yet.
/**
 * Hook to check if the "Advisory" feature flag is enabled.
 */
export const useFlagAdvisory = () => true;
// useIsFeatureFlagEnabled(FEATURE_FLAG_ADVISORY);
